import React, { useState, useEffect, useContext } from "react";
import AdminLayout from "../../../../layouts/admin/AdminLayout";
import axios from "axios";
import AppContext from "../../../../context/AppContext";
import "../../../../assets/css/admin/dashboardcss/AdminAppointments.css";
import { Badge } from "react-bootstrap";
import { checkLoggedInAdmin } from "../../../../helper/CustomHelper";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

export default function Bookings() {
  const { baseUrl, baseUrlForFile } = useContext(AppContext);
  const navigate = useNavigate();

  const [bookings, setBookings] = useState([]);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("All");
  const [imagePreview, setImagePreview] = useState(null);
  const [loading, setLoading] = useState(false);

  const filters = ["All", "Pending", "Approved", "Rejected",];

  // =========================
  // VIEW ALL APPOINTMENTS
  // =========================
  const viewAllAppointments = () => {
    axios
      .post(`${baseUrl}/admin/appointments/viewAll`, {})
      .then((response) => {
        console.log("APPOINTMENTS:", response.data);

        setBookings(response.data.appointments || []);
      })
      .catch((error) => {
        console.log("API ERROR:", error);

        setBookings([]);

        Swal.fire({
          icon: "error",
          title: "Unable to Load Bookings",
          text:
            error.response?.data?.message ||
            "Something went wrong while loading bookings.",
          confirmButtonColor: "#e0456e",
        });
      });
  };

  // =========================
  // PAGE LOAD
  // =========================
  useEffect(() => {
    checkLoggedInAdmin(navigate);
    viewAllAppointments();
  }, []);

  // =========================
  // UPDATE STATUS
  // =========================
  const handleUpdateStatus = (id, status) => {
    let actionText = "";

    if (status === "Approved") {
      actionText = "approve this appointment";
    } else if (status === "Rejected") {
      actionText = "reject this appointment";
    } else if (status === "complete") {
      actionText = "mark this appointment as complete";
    }

    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to ${actionText}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#e0456e",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, continue",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    }).then((result) => {
      if (!result.isConfirmed) {
        return;
      }

      setLoading(true);

      axios
        .post(`${baseUrl}/admin/appointments/updateStatus`, {
          appointment_id: id,
          status: status,
        })
        .then((response) => {
          console.log("STATUS UPDATE:", response.data);

          Swal.fire({
            icon: "success",
            title: "Success!",
            text:
              status === "complete"
                ? "Appointment completed successfully."
                : `Appointment ${status.toLowerCase()} successfully.`,
            confirmButtonColor: "#e0456e",
          });

          viewAllAppointments();
        })
        .catch((error) => {
          console.log("STATUS UPDATE ERROR:", error);

          Swal.fire({
            icon: "error",
            title: "Update Failed!",
            text:
              error.response?.data?.message ||
              "Unable to update appointment status.",
            confirmButtonColor: "#e0456e",
          });
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };

  // =========================
  // CANCEL APPOINTMENT
  // =========================
  // const handleCancelAppointment = (id) => {
  //   Swal.fire({
  //     title: "Cancel Appointment?",
  //     text: "This appointment will be cancelled.",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#e0456e",
  //     cancelButtonColor: "#6c757d",
  //     confirmButtonText: "Yes, cancel it!",
  //     cancelButtonText: "No, keep it",
  //     reverseButtons: true,
  //   }).then((result) => {
  //     if (!result.isConfirmed) {
  //       return;
  //     }

  //     setLoading(true);

  //     axios
  //       .post(`${baseUrl}/admin/appointments/cancelAppointment`, {
  //         appointment_id: id,
  //       })
  //       .then((response) => {
  //         console.log("CANCEL SUCCESS:", response.data);

  //         Swal.fire({
  //           icon: "success",
  //           title: "Cancelled!",
  //           text: "Appointment cancelled successfully.",
  //           confirmButtonColor: "#e0456e",
  //         });

  //         viewAllAppointments();
  //       })
  //       .catch((error) => {
  //         console.log("CANCEL ERROR:", error);

  //         Swal.fire({
  //           icon: "error",
  //           title: "Cancellation Failed!",
  //           text:
  //             error.response?.data?.message || "Unable to cancel appointment.",
  //           confirmButtonColor: "#e0456e",
  //         });
  //       })
  //       .finally(() => {
  //         setLoading(false);
  //       });
  //   });
  // };

  // =========================
  // FILTER CHANGE
  // =========================
  const handleFilterChange = (value) => {
    setFilter(value);
  };

  // =========================
  // IMAGE PREVIEW
  // =========================
  const openImage = (src) => {
    setImagePreview(src);
  };

  // =========================
  // FILTER BOOKINGS
  // =========================
  const filteredBookings = bookings.filter((booking) => {
    const matchesFilter =
      filter === "All" ||
      booking.status?.toLowerCase() === filter.toLowerCase();

    const searchValue = search.toLowerCase();

    const matchesSearch =
      booking.id?.toString().includes(searchValue) ||
      booking.escustomer?.fullname?.toLowerCase().includes(searchValue) ||
      booking.escustomer?.phone?.toLowerCase().includes(searchValue) ||
      booking.estreatment?.name?.toLowerCase().includes(searchValue) ||
      booking.esdeal?.title?.toLowerCase().includes(searchValue);

    return matchesFilter && matchesSearch;
  });

  return (
    <AdminLayout>
      <div className="bk-wrapper">
        {/* ================= HEADER ================= */}
        <div className="bk-header">
          <div>
            <h1 className="bk-title">Bookings</h1>

            <p className="bk-subtitle">
              Approve, reject or follow up on incoming bookings.
            </p>
          </div>
        </div>

        {/* ================= SEARCH + FILTERS ================= */}
        <div className="bk-controls">
          {/* SEARCH */}
          <div className="bk-search-wrap">
            <span className="bk-search-icon">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <circle cx="11" cy="11" r="7" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
            </span>

            <input
              type="text"
              className="bk-search"
              placeholder="Search bookings..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          {/* FILTERS */}
          <div className="bk-filters">
            {filters.map((item) => (
              <button
                key={item}
                className={`bk-filter-btn ${
                  filter === item ? "active" : ""
                } filter-${item.toLowerCase()}`}
                onClick={() => handleFilterChange(item)}
              >
                {item}
              </button>
            ))}
          </div>
        </div>

        {/* ================= TABLE ================= */}
        <div className="bk-table-wrap">
          <table className="bk-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>IMAGE</th>
                <th>CLIENT</th>
                <th>SERVICE/DEAL</th>
                <th>WHEN</th>
                <th>STATUS</th>
                <th>ACTIONS</th>
              </tr>
            </thead>

            <tbody>
              {filteredBookings.length === 0 ? (
                <tr>
                  <td colSpan={7} className="bk-empty">
                    No bookings found.
                  </td>
                </tr>
              ) : (
                filteredBookings.map((booking) => {
                  const status = booking.status?.toLowerCase();

                  return (
                    <tr key={booking.id} className="bk-row">
                      {/* ================= ID ================= */}
                      <td className="bk-id">{booking.id}</td>

                      {/* ================= IMAGE ================= */}
                      <td>
                        {booking.image ? (
                          <img
                            src={`${baseUrlForFile}/${booking.image}`}
                            alt="attachment"
                            className="bk-thumb"
                            onClick={() =>
                              openImage(`${baseUrlForFile}/${booking.image}`)
                            }
                          />
                        ) : (
                          <div className="bk-thumb-empty">
                            <img
                              src={`https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSTcU9Q1YYFLBh-J5rNc9iIO5tQ7OEAdQAOcVkUCE48FA&s=10`}
                              alt="attachment"
                              className="bk-thumb"
                              onClick={() =>
                                openImage(`https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSTcU9Q1YYFLBh-J5rNc9iIO5tQ7OEAdQAOcVkUCE48FA&s=10`)
                              }
                            />
                          </div>
                        )}
                      </td>

                      {/* ================= CLIENT ================= */}
                      <td>
                        <div className="bk-client-name">
                          {booking.escustomer?.fullname}
                        </div>

                        <div className="bk-client-phone">
                          {booking.escustomer?.phone}
                        </div>
                      </td>

                      {/* ================= SERVICE / DEAL ================= */}
                      <td className="bk-service">
                        {booking.esdeal ? (
                          <>
                            {booking.esdeal.title}

                            <br />

                            <sup>
                              <Badge>DEAL</Badge>
                            </sup>
                          </>
                        ) : (
                          <>
                            {booking.estreatment?.name}

                            <br />

                            <sup>
                              <Badge bg="success">Treatment</Badge>
                            </sup>
                          </>
                        )}
                      </td>

                      {/* ================= WHEN ================= */}
                      <td className="bk-when">
                        {booking.appointment_date} ({booking.appointment_time})
                      </td>

                      {/* ================= STATUS ================= */}
                      <td>
                        <span className={`bk-badge status-${status}`}>
                          {booking.status}
                        </span>
                      </td>

                      {/* ================= ACTIONS ================= */}
                      <td>
                        <div className="bk-actions">
                          {/* APPROVED -> MARK COMPLETE */}
                          {booking.status === "Approved" ? (
                            <button
                              className="bk-btn btn-approve"
                              disabled={loading || status === "complete"}
                              onClick={() =>
                                handleUpdateStatus(booking.id, "complete")
                              }
                            >
                              {loading ? "Please wait..." : "Mark Complete"}
                            </button>
                          ) : (
                            /* APPROVE */
                            <button
                              className="bk-btn btn-approve"
                              disabled={
                                loading ||
                                status === "approved" ||
                                status === "cancelled" ||
                                status === "complete"
                              }
                              onClick={() =>
                                handleUpdateStatus(booking.id, "Approved")
                              }
                            >
                              Approve
                            </button>
                          )}

                          {/* REJECT */}
                          <button
                            className="bk-btn btn-reject"
                            disabled={
                              loading ||
                              status === "rejected" ||
                              status === "cancelled" ||
                              status === "complete"
                            }
                            onClick={() =>
                              handleUpdateStatus(booking.id, "Rejected")
                            }
                          >
                            Reject
                          </button>

                          {/* CANCEL */}
                          {/* {status !== "cancelled" &&
                            status !== "rejected" &&
                            status !== "complete" && (
                              <button
                                className="bk-btn btn-reject"
                                disabled={loading}
                                onClick={() =>
                                  handleCancelAppointment(booking.id)
                                }
                              >
                                Cancel
                              </button>
                            )} */}
                        </div>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>

        {/* ================= IMAGE PREVIEW ================= */}
        {imagePreview && (
          <div
            className="bk-overlay bk-img-overlay"
            onClick={() => setImagePreview(null)}
          >
            <div
              className="bk-img-lightbox"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="bk-modal-close bk-img-close"
                onClick={() => setImagePreview(null)}
              >
                ✕
              </button>

              <img src={imagePreview} alt="preview" className="bk-img-full" />
            </div>
          </div>
        )}
      </div>
    </AdminLayout>
  );
}
